"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AccordionItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("..");

var _Accordion = require("./Accordion.style");

var _excluded = ["children", "onClick", "itemProps", "iconDefault", "iconActive", "activeItem"],
    _excluded2 = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      itemProps = _ref.itemProps,
      iconDefault = _ref.iconDefault,
      iconActive = _ref.iconActive,
      activeItem = _ref.activeItem,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(activeItem >= 0 ? activeItem : null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  (0, _react.useEffect)(function () {
    var newActiveItem = activeItem >= 0 ? activeItem : null;
    setActiveIndex(newActiveItem);
  }, [activeItem]);
  var elements = (0, _react.useMemo)(function () {
    return _react["default"].Children.toArray(children).filter(function (el) {
      return (0, _typeof2["default"])(el.type);
    });
  }, [children]);

  var handleAccordionChange = function handleAccordionChange(index) {
    setActiveIndex(activeIndex === index ? null : index);
    typeof onClick === 'function' && onClick(index);
  };

  return /*#__PURE__*/_react["default"].createElement(_Accordion.StyledAccordionContainer, props, elements.length && elements.map(function (acc, i) {
    var _acc$props = acc.props,
        title = _acc$props.title,
        subTitle = _acc$props.subTitle,
        children = _acc$props.children,
        disabled = _acc$props.disabled;
    return /*#__PURE__*/_react["default"].createElement(_Accordion.StyledAccordionItem, (0, _extends2["default"])({
      key: "accordion-item-".concat(i),
      disabled: disabled
    }, itemProps), /*#__PURE__*/_react["default"].createElement(_Accordion.StyledAccordionItemTitle, {
      onClick: function onClick() {
        return handleAccordionChange(i);
      },
      isActive: i === activeIndex
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "eui-accordion-title"
    }, title, subTitle && /*#__PURE__*/_react["default"].createElement("span", {
      className: "eui-sub-title"
    }, subTitle)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "eui-accordion-icon"
    }, /*#__PURE__*/_react["default"].createElement(_.Icon, {
      iconName: iconDefault && iconActive ? activeIndex === i ? iconActive : iconDefault : activeIndex === i ? 'UpperArrow' : 'DownArrow',
      size: 24
    }))), /*#__PURE__*/_react["default"].createElement(_Accordion.StyledAccordionItemContent, {
      active: activeIndex === i,
      className: "eui-accordion-content"
    }, children));
  }));
};

var AccordionItem = function AccordionItem(_ref2) {
  var children = _ref2.children,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("div", props, children);
};

exports.AccordionItem = AccordionItem;
AccordionItem.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
Accordion.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].element), _propTypes["default"].element]),
  onClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  itemProps: _propTypes["default"].object,
  iconDefault: _propTypes["default"].string,
  iconActive: _propTypes["default"].string,
  activeItem: _propTypes["default"].number
};
var _default = Accordion;
exports["default"] = _default;